import React from "react";
import AnimatedSection from "./AnimatedSection";
import { useTranslation } from "react-i18next";
import "../i18n"; // Import i18n setup

const TermsCondition = () => {
    const { t } = useTranslation();

    return (
        <section id="privacy-policy" className="py-16 text-white">
            {/* <AnimatedSection> */}
            <div className="container mx-auto flex flex-col lg:flex-row items-center px-6 lg:px-20">
                <div className="py-10 mx-auto">
                    <h1 className="text-center text-3xl sm:text-4xl font-extrabold mb-6">
                        Terms and Conditions
                    </h1>

                    <p className="text-base sm:text-lg mb-4">
                        DECIMIC is the operator of this website.
                    </p>
                    <p className="text-base text-justify sm:text-lg mb-4">
                        DECIMIC is a limited company duly incorporated in Japan, with its registered office located at 3-119-2, Miyagayato, Minuma Ku, Saitama Shi, Saitama, 337-0011, Japan.
                    </p>
                    <p className="text-base sm:text-lg mb-4">
                        For any inquiries or communication, you can reach us at contact@decimic.com
                    </p>

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            1. Responsibility for Users Accessing Our Website Through Your Device or Internet Connection
                        </h2>

                        <p className="mb-4 text-justify">
                            You are responsible for ensuring that anyone who accesses our website through your devices or internet connection is fully informed of
                            these Website Terms and Conditions and any other relevant documentation. Additionally, you must ensure that such individuals agree to
                            abide by and comply with these terms. If they do not agree to be bound by these terms, they are not permitted to access or use the website,
                            and you must prevent them from doing so.
                        </p>
                    </div>
                    {/* End of Responsibility for Users */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            2. Additional Documents Governing Your Use of Our Website
                        </h2>

                        <p className="mb-4 text-justify">
                            Along with these Website Terms and Conditions, your use of our website is also subject to the following documents:
                        </p>
                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Privacy Notice:</p>
                                <p className="text-base leading-relaxed">
                                    Available at
                                    <a href="/privacypolicy" class="text-blue-500 hover:text-blue-900 ml-1">
                                        Privacy Policy
                                    </a>.
                                    This document outlines how DECIMIC collects, uses, and protects your personal
                                    information. It details the types of data we gather, the reasons for collection, how we use the data, and the circumstances
                                    under which we may share it with third parties. It also explains your rights regarding the information we collect and process.
                                </p>
                            </div>
                            <div>
                                <p className="font-bold text-lg mb-1">Cookie Policy:</p>
                                <p className="text-base leading-relaxed">
                                    Available at
                                    <a href="/cookiepolicy" class="text-blue-500 hover:text-blue-900 ml-1">
                                        Cookie Policy
                                    </a>.
                                    This policy explains how DECIMIC uses cookies and similar technologies on our website. It provides details on the types of
                                    cookies we utilize, the purposes they serve, and how you can manage your cookie preferences and browser settings,
                                    including how to accept or reject cookies.
                                </p>
                            </div>
                        </div>
                        <p className="mb-4 text-justify">
                            By accessing and using our website, you agree to comply with these Website Terms and Conditions. You also acknowledge that your
                            information will be handled in accordance with our Privacy Notice and that cookies will be used in line with our Cookie Policy.
                        </p>
                        <p className="mb-4 text-justify">
                            If you do not accept the terms outlined in these Website Terms and Conditions, you must refrain from using our website.
                        </p>
                    </div>
                    {/* End of Responsibility for Users */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            3. Legal Rights to Creations
                        </h2>

                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Ownership:</p>
                                <p className="text-base leading-relaxed">
                                    All content on this website, including text, graphics, and logos, is the intellectual property of DECIMIC.
                                </p>
                            </div>
                            <div>
                                <p className="font-bold text-lg mb-1">Restrictions:</p>
                                <p className="text-base leading-relaxed">
                                    Available at
                                    <a href="/cookiepolicy" class="text-blue-500 hover:text-blue-900 ml-1">
                                        Cookie Policy
                                    </a>.
                                    You may not reproduce, distribute, or exploit any material without prior written consent.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* End of Legal Rights to Creations */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            4. Indemnification Agreement
                        </h2>

                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Indemnification Obligation:</p>
                                <p className="text-base leading-relaxed text-justify">
                                    You, as well as any third party for whom you manage an account or perform activities on the website, agree to defend
                                    (upon our request), compensate, and hold DECIMIC harmless from any claims, losses, damages, liabilities, or expenses.
                                    This includes, but is not limited to, reasonable legal fees, arising from or related to the following actions (whether
                                    directly caused by your activities on the website or those conducted on your behalf):
                                </p>
                                <div className="pl-4 sm:pl-6">
                                    <ul className="list-disc space-y-2 mt-6">
                                        <li>Your uploads, access, or use of the website.</li>
                                        <li>Your violation or suspected violation of these Website Terms and Conditions.</li>
                                        <li>Your infringement of any third-party rights, including intellectual property, privacy, confidentiality, publicity, or property rights.</li>
                                        <li>Your breach of any relevant laws, rules, regulations, codes, or orders from governmental or quasi-governmental bodies, including regulatory and legislative authorities.</li>
                                        <li>Any false or misleading representations made by you.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12 mt-4">
                            <div>
                                <p className="font-bold text-lg mb-1">Cooperation in Defense:</p>
                                <p className="text-base leading-relaxed text-justify">
                                    You agree to provide full cooperation as required by DECIMIC in the defense of any claim. DECIMIC reserves the right to take
                                    exclusive control over the defense and resolution of any claim subject to indemnification, and you agree not to settle any
                                    claim without DECIMIC's prior written consent.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* End of Cooperation in Defense */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            5. Disclaimer of Warranties and Limitation of Liability
                        </h2>

                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">No Warranties:</p>
                                <p className="text-base leading-relaxed text-justify">
                                    All content on this website, including text, graphics, logos, software, documents, FAQs, and other materials, is the intellectual
                                    property of DECIMIC Inc. While we strive to provide accurate and up-to-date information, we do not guarantee its accuracy, completeness,
                                    reliability, or suitability for any purpose.
                                </p>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12 mt-4">
                            <div>
                                <p className="font-bold text-lg mb-1">Limitation of Liability:</p>
                                <p className="text-base leading-relaxed text-justify">
                                    DECIMIC Inc. shall not be held liable for any damages, losses, or disruptions arising from:
                                </p>
                                <div className="pl-4 sm:pl-6">
                                    <ul className="list-disc space-y-2 mt-6">
                                        <li>The misuse of products or services.</li>
                                        <li>Delays in delivery due to unforeseen circumstances.</li>
                                        <li>Factors beyond our control, including technical failures, cyber threats, or third-party actions.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Accuracy of Information:</p>
                                <p className="text-base leading-relaxed text-justify">
                                    DECIMIC Inc. disclaims all responsibility for any errors, inaccuracies, or omissions in the information available on this website.
                                    This includes, but is not limited to, software, documents, FAQs, or any other content.
                                </p>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Errors and Omissions:</p>
                                <p className="text-base leading-relaxed text-justify">
                                    We do not warrant that the website will be error-free, uninterrupted, or free of harmful components, including viruses or malware.
                                    We do not guarantee that defects will be corrected or that the website is compatible with all devices or browsers.
                                </p>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Use of Information:</p>
                                <p className="text-base leading-relaxed text-justify">
                                    Any reliance on the information provided on this website is at your <span class="font-bold">own risk</span>. DECIMIC Inc. is not responsible for <span class="font-bold">any harm, injury, loss, or damages </span>
                                    resulting from the use or misuse of information found on this site.
                                </p>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Changes and Updates:</p>
                                <p className="text-base leading-relaxed text-justify">
                                    DECIMIC Inc. reserves the right to modify, update, or remove any content on this website at any time without prior notice. Users are encouraged to review this disclaimer periodically for updates.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* End of Disclaimer of Warranties and Limitation of Liability */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            6. Website Availability & Access
                        </h2>

                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="text-base leading-relaxed text-justify">
                                    DECIMIC does not guarantee that its website will be available at all times or from any specific location. Access may be
                                    interrupted due to maintenance, software updates, technical issues, or factors beyond our control, such as disruptions
                                    from third-party service providers.
                                </p>
                                <p className="text-base leading-relaxed text-justify mt-6">
                                    While we strive to maintain seamless access, we make no warranties that:
                                </p>
                                <div className="pl-4 sm:pl-6">
                                    <ul className="list-disc space-y-2 mt-6">
                                        <li>The website will always be available or accessible from all regions.</li>
                                        <li>Access will be uninterrupted or error-free.</li>
                                        <li>The website will function optimally across all devices, browsers, or operating systems.</li>
                                    </ul>
                                </div>
                                <p className="text-base leading-relaxed text-justify mt-6">
                                    DECIMIC reserves the right to suspend or restrict access to all or parts of the website for operational, business, or security
                                    reasons, including but not limited to updates, content modifications, or system improvements. Where feasible, we will provide
                                    prior notice for extended downtime.
                                </p>
                                <p className="text-base leading-relaxed text-justify mt-6">
                                    By using our website, you acknowledge that DECIMIC is not liable for any inconvenience, data loss, or damages resulting from
                                    temporary unavailability or interruptions.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* End of Website Availability & Access */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            7. Intellectual Property & Privacy Protection
                        </h2>

                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Copyright & Intellectual Property:</p>
                                <p className="text-base leading-relaxed text-justify">
                                    All content on this website, including these Terms and Conditions, text, graphics, logos, and other materials, is either owned by or licensed to
                                    DECIMIC and is protected by copyright laws worldwide. Unless explicitly stated otherwise, all intellectual property rights in this document and
                                    throughout our website are reserved. Unauthorized use, reproduction, or distribution of any content is strictly prohibited.
                                </p>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12 mt-4">
                            <div>
                                <p className="font-bold text-lg mb-1">Privacy Protection:</p>
                                <p className="text-base leading-relaxed text-justify">
                                    We prioritize your privacy. Any personal information collected during transactions or interactions with our website is handled in strict accordance
                                    with our Privacy Policy to ensure the security and confidentiality of your data.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* End of Intellectual Property & Privacy Protection */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            8. Third-Party Links & External Websites
                        </h2>

                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="text-base leading-relaxed text-justify">
                                    DECIMIC's website may include links to third-party websites or services for reference or convenience. These external sites operate independently,
                                    and DECIMIC does not endorse, control, or take responsibility for their content, functionality, accuracy, or policies.<br />
                                    If you choose to access a third-party website through a link on DECIMIC's website, please be aware that:
                                </p>
                                <div className="pl-4 sm:pl-6">
                                    <ul className="list-disc space-y-2 mt-6">
                                        <li>The content and services on these external sites are beyond our control, and we make no guarantees regarding their relevance, accuracy, or compliance with laws.</li>
                                        <li>Any interaction with third-party websites, including the sharing of personal information, is at your own discretion. DECIMIC is not responsible for how these external sites collect, use, or process your data.</li>
                                        <li>We strongly advise reviewing the terms, conditions, and privacy policies of any third-party website before use.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End of Intellectual Property & Privacy Protection */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            9. Governing Law and Dispute Resolution
                        </h2>
                        <p className="text-base sm:text-lg mb-4">
                            To ensure the best experience on our website, we recommend using the latest versions of the following browsers:
                        </p>

                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">For Computers:</p>
                                <p className="text-base leading-relaxed text-justify">
                                    These terms are governed by and construed in accordance with the laws of Japan.
                                </p>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12 mt-4">
                            <div>
                                <p className="font-bold text-lg mb-1">Dispute Resolution:</p>
                                <p className="text-base leading-relaxed text-justify">
                                    In the unlikely event of a dispute, we encourage resolution through mutual dialogue. If unresolved, disputes will be handled according to Japanese law.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* End of Governing Law and Dispute Resolution */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            10. Preferred Browsers & Compatibility
                        </h2>
                        <p className="text-base leading-relaxed text-justify">
                            For Computers:
                        </p>

                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="text-base leading-relaxed text-justify">
                                    Windows:
                                </p>
                                <div className="pl-4 sm:pl-6">
                                    <ul className="list-disc space-y-2 mt-6">
                                        <li>Microsoft Edge (Latest Version)</li>
                                        <li>Mozilla Firefox (Latest Version)</li>
                                        <li>Google Chrome (Latest Version)</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="text-base leading-relaxed text-justify">
                                    Mac (macOS):
                                </p>
                                <div className="pl-4 sm:pl-6">
                                    <ul className="list-disc space-y-2 mt-6">
                                        <li>Safari (Latest Version)</li>
                                        <li>Google Chrome (Latest Version)</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <p className="text-base leading-relaxed text-justify mt-6">
                            For Smartphones:
                        </p>

                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="text-base leading-relaxed text-justify">
                                    iPhone (iOS):
                                </p>
                                <div className="pl-4 sm:pl-6">
                                    <ul className="list-disc space-y-2 mt-6">
                                        <li>Safari (Latest Version)</li>
                                        <li>Google Chrome (Latest Version)</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="text-base leading-relaxed text-justify">
                                    Android:
                                </p>
                                <div className="pl-4 sm:pl-6">
                                    <ul className="list-disc space-y-2 mt-6">
                                        <li>Google Chrome (Latest Version)</li>
                                    </ul>
                                </div>
                            </div>
                        </div>


                        <p className="text-base leading-relaxed text-justify mt-6">
                            For Tablets:
                        </p>
                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="text-base leading-relaxed text-justify">
                                    iPad (iOS):
                                </p>
                                <div className="pl-4 sm:pl-6">
                                    <ul className="list-disc space-y-2 mt-6">
                                        <li>Safari (Latest Version)</li>
                                        <li>Google Chrome (Latest Version)</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="text-base leading-relaxed text-justify">
                                    Android Tablets:
                                </p>
                                <div className="pl-4 sm:pl-6">
                                    <ul className="list-disc space-y-2 mt-6">
                                        <li>Google Chrome (Latest Version)</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="space-y-6 pl-8 sm:pl-12 mt-4">
                            <div>
                                <p className="font-bold text-lg mb-1">Important Notes:</p>
                                <div className="space-y-6 pl-8 sm:pl-12">
                                    <div className="pl-4 sm:pl-6">
                                        <ul className="list-disc space-y-2 mt-6">
                                            <li>Using a browser outside the preferred list may result in limited functionality or improper display.</li>
                                            <li>Even within the preferred environment, certain browser settings or configurations may affect how the website is displayed and used.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End of Preferred Browsers & Compatibility */}


                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            11. Acceptable Use of Website Content
                        </h2>

                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Personal and Organizational Use:</p>
                                <p className="text-base leading-relaxed text-justify">
                                    The materials and content available on DECIMIC’s website are provided solely for personal, private, and non-commercial purposes.
                                    You may print, share, or reference content for lawful personal use or to inform members within your organization. However, extracting,
                                    reproducing, or distributing content beyond these permitted uses requires prior written approval from DECIMIC.
                                </p>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12 mt-4">
                            <div>
                                <p className="font-bold text-lg mb-1">Restrictions on Modifications and Alterations:</p>
                                <p className="text-base leading-relaxed text-justify">
                                    When printing, downloading, or sharing any content from DECIMIC’s website, the following conditions must be met:
                                </p>
                                <div className="pl-4 sm:pl-6">
                                    <ul className="list-disc space-y-2 mt-6">
                                        <li>The content must remain unchanged, with no modifications, additions, or deletions.</li>
                                        <li>Images, media, or graphics must not be altered in any way.</li>
                                        <li>Any accompanying text, captions, or attributions must remain intact.</li>
                                        <li>Any content shared externally must accurately represent the original material as it appears on DECIMIC’s website.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Prohibited Data Extraction Methods:</p>
                                <p className="text-base leading-relaxed text-justify">
                                    The use of automated tools, such as web crawlers, data mining software, scraping technology, or any similar third-party tools,
                                    to extract or copy content from DECIMIC’s website is strictly prohibited unless prior written consent is obtained.
                                </p>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Proper Attribution of Content:</p>
                                <p className="text-base leading-relaxed text-justify">
                                    If any materials or content from DECIMIC’s website are shared with others, proper acknowledgment must be given to DECIMIC
                                    (or any other credited authors as indicated).
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* End of Acceptable Use of Website Content */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            12. Restricted Use of DECIMIC’s Website
                        </h2>

                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Unauthorized Reproduction and Copying:</p>
                                <p className="text-base leading-relaxed text-justify">
                                    You are not permitted to reproduce, duplicate, copy, or resell any portion of DECIMIC’s website or its content,
                                    except where explicitly allowed in the applicable terms and conditions.
                                </p>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Website Access and Security:</p>
                                <p className="text-base leading-relaxed text-justify">
                                    Without prior written approval from DECIMIC, you must not access, interfere with, damage, or disrupt any part of the website, including:
                                </p>

                                <div className="pl-4 sm:pl-6">
                                    <ul className="list-disc space-y-2 mt-6">
                                        <li>DECIMIC’s systems, hardware, servers, or networks.</li>
                                        <li>Any third-party networks hosting DECIMIC’s website.</li>
                                        <li>Software used to develop, modify, or maintain the website.</li>
                                        <li>Any technologies owned or operated by DECIMIC or authorized third parties.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Lawful Use of the Website:</p>
                                <p className="text-base leading-relaxed text-justify">
                                    You are required to use DECIMIC’s website only for legal purposes and in compliance with applicable terms. The following uses are strictly prohibited:
                                </p>

                                <div className="pl-4 sm:pl-6">
                                    <ul className="list-disc space-y-2 mt-6">
                                        <li>Engaging in any unlawful activities or violating any local, national, or international regulations.</li>
                                        <li>Conducting fraudulent transactions or activities.</li>
                                        <li>Sending unsolicited advertisements, spam, or unauthorized marketing communications.</li>
                                        <li>Uploading or distributing malicious software such as viruses, spyware, adware, worms, Trojan horses, or any harmful code that could disrupt DECIMIC’s website, user devices, or third-party systems.</li>
                                        <li>Communicating with or attempting to harm minors in any way.</li>
                                        <li>Using the website in any manner that conflicts with DECIMIC’s terms and policies.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12 mt-6">
                            <div>
                                <p className="font-bold text-lg mb-1">Restrictions on Personal Data Submission:</p>

                                <div className="pl-4 sm:pl-6">
                                    <ul className="list-disc space-y-2">
                                        <li>You must not provide any personal information if you are under 18 years of age.</li>
                                        <li>You must not submit personal data about another individual unless:
                                            <ul className="list-[square] pl-5 mt-1 space-y-1">
                                                <li>They are under 18, in which case submission is not allowed.</li>
                                                <li>They are 18 or older, and you have obtained their explicit consent before sharing their details with DECIMIC.</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12 mt-6">
                            <div>
                                <p className="font-bold text-lg mb-1">Restrictions on Sensitive Personal Information:</p>

                                <p className="text-base leading-relaxed text-justify">
                                    You must not submit sensitive personal data, which includes but is not limited to:
                                </p>
                                <div className="pl-4 sm:pl-6">
                                    <ul className="list-disc space-y-2">
                                        <li>Racial or ethnic background</li>
                                        <li>Political opinions</li>
                                        <li>Religious or philosophical beliefs</li>
                                        <li>Trade union membership</li>
                                        <li>Genetic or biometric data</li>
                                        <li>Health-related information</li>
                                        <li>Sexual orientation or related details</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12 mt-6">
                            <div>
                                <p className="font-bold text-lg mb-1">Handling of Incorrectly Submitted Sensitive Information:</p>

                                <p className="text-base leading-relaxed text-justify">
                                    If you accidentally or deliberately submit sensitive personal data to DECIMIC, you acknowledge and consent to its processing under the
                                    applicable provisions of the Act on the Protection of Personal Information (APPI), Articles 16(1), 17 & 18.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* end of Restricted Use of DECIMIC’s Website */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            13. Website Security and Cyber Protection
                        </h2>

                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Protection Against Malware and Security Threats:</p>
                                <div className="pl-4 sm:pl-6">
                                    <ul className="list-disc space-y-2 mt-6">
                                        <li>DECIMIC takes reasonable precautions to safeguard its website from malware, viruses, and other security threats. However, we cannot guarantee that the website is entirely free from such risks.</li>
                                        <li>DECIMIC is not liable for any viruses, bugs, or malicious software that may be transmitted from the website to your device, nor for any resulting damage or disruptions.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">User Responsibilities for Cybersecurity:</p>

                                <div className="pl-4 sm:pl-6">
                                    <ul className="list-disc space-y-2 mt-6">
                                        <li>You are responsible for ensuring that your device is equipped with up-to-date antivirus protection before accessing DECIMIC’s website.</li>
                                        <li>You must not introduce or upload any form of malicious software, including viruses, spyware, malware, adware, Trojan horses, worms, logic bombs, or keyloggers, onto the website.</li>
                                        <li>Attempting to gain unauthorized access to DECIMIC’s website, servers, databases, or internal systems through hacking tools, third-party software, or any other means is strictly prohibited.</li>
                                        <li>You must not engage in denial-of-service (DoS) attacks or any other activities that may compromise the website’s functionality.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div>
                                <p className="font-bold text-lg mb-1">Compliance with Cybersecurity Regulations:</p>

                                <div className="pl-4 sm:pl-6">
                                    <ul className="list-disc space-y-2 mt-6">
                                        <li>Unauthorized access to computer systems, misuse of login credentials, or distribution of hacking tools is prohibited under the Act on Prohibition of Unauthorized Computer Access (1999).</li>
                                        <li>Cybercrimes such as fraud, unauthorized data alteration, and intentional destruction of digital information are offenses under Japan’s Penal Code (1907).</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End of Website Security and Cyber Protection */}

                    <div className="pl-4 sm:pl-6">
                        <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                            14. Age Restrictions for Website Use
                        </h2>

                        <div className="space-y-6 pl-8 sm:pl-12">
                            <div className="text-justify text-lg">
                                <p className="mb-1">
                                    DECIMIC’s website, along with any products or services offered through it, is not intended for individuals under
                                    the age of 18.</p>
                                <p className="text-base leading-relaxed mt-4">
                                    IF YOU ARE UNDER 18 YEARS OLD, YOU ARE PROHIBITED FROM USING DECIMIC’S WEBSITE, PURCHASING OR ATTEMPTING TO PURCHASE
                                    ANY PRODUCTS OR SERVICES, OR SUBMITTING ANY PERSONAL INFORMATION ABOUT YOURSELF OR OTHERS.
                                </p>
                                <p className="text-base leading-relaxed mt-4">
                                    DECIMIC does not knowingly collect, store, or process any information related to individuals under the age of 18.
                                </p>
                            </div>
                        </div>
                        {/* End of Age Restrictions for Website Use */}


                        <div className="pl-4 sm:pl-6">
                            <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                                15. Linking to DECIMIC’s Website
                            </h2>

                            <div className="space-y-6 pl-8 sm:pl-12">
                                <div>
                                    <p className="font-bold text-lg mb-1">Permission to Link:</p>
                                    <p className="text-base leading-relaxed text-justify mt-4">
                                        You are not allowed to create links to DECIMIC’s website unless you have received prior written approval from DECIMIC.
                                    </p>
                                </div>
                            </div>
                            <div className="space-y-6 pl-8 sm:pl-12">
                                <div>
                                    <p className="font-bold text-lg mb-1">Conditions for Approved Links:</p>
                                    <p className="text-base leading-relaxed text-justify mt-4">
                                        If DECIMIC grants you permission to link to its website, the following conditions apply:
                                    </p>
                                    <div className="pl-4 sm:pl-6">
                                        <ul className="list-disc space-y-2 mt-6">
                                            <li>You may only place links on websites that you own, ensuring that both the websites and the links comply with these Website Terms and Conditions.</li>
                                            <li>Any link to DECIMIC’s website must be used responsibly and must not be misleading, defamatory, or harmful to DECIMIC’s reputation or business in any way.</li>
                                            <li>You must not use links in a way that implies any partnership, affiliation, endorsement, or business relationship with DECIMIC unless explicitly agreed upon in writing.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="space-y-6 pl-8 sm:pl-12">
                                <div>
                                    <p className="font-bold text-lg mb-1">Revocation of Permission:</p>

                                    <div className="pl-4 sm:pl-6">
                                        <ul className="list-disc space-y-2 mt-6">
                                            <li>DECIMIC reserves the right to revoke linking permission at any time.</li>
                                            <li>If DECIMIC notifies you that permission has been withdrawn, you must immediately remove any links to DECIMIC’s website.</li>
                                            <li>The collection, use, or sharing of personal data must comply with the Act on the Protection of Personal Information (APPI, 2003; amended in 2015 and 2020). Any handling of personal data must adhere to legal privacy and security standards.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End of Linking to DECIMIC’s Website */}

                        <div className="pl-4 sm:pl-6">
                            <h2 className="text-2xl sm:text-3xl font-bold mb-4 mt-6">
                                16. Copyright
                            </h2>

                            <div className="space-y-6 pl-8 sm:pl-12">
                                <div>
                                    <p className="font-bold text-lg mb-1">The copyright to the document provided on this website belongs to DECIMIC Inc or to third parties.</p>
                                    <p className="text-base leading-relaxed text-justify mt-4">
                                        Reproduction, alteration, redistribution, republication, downloading, display, notification or transmission is forbidden in
                                        total or in part, in any format, by any means, without the express prior permission of DECIMIC Inc or the copyright owner.
                                    </p>
                                </div>
                            </div>
                        </div>
                        {/* End of Copyright */}

                    </div>
                </div>

            </div>
        </section >
    );
};

export default TermsCondition;